import './VerifyEmailAlert.scss';

import * as React from 'react';

import { translate } from '~l10n/client';
import { useAtomValue } from 'jotai';

import { languageAtom } from '~shared/atoms/languageAtom';
import { useVerificationStatus } from '~teacher/hook/account';

import { VerificationStatus } from '../../../api/account/types';
import { AlertMessage } from '../AlertMessage';
import { Link } from '../Link';

const VERIFY_EMAIL_ALERT_EXPIRATION_DATE = new Date(2025, 4, 31);

export function VerifyEmailAlert() {
  const language = useAtomValue(languageAtom);

  const verificationStatus = useVerificationStatus();
  if (verificationStatus.data === undefined) {
    return <div className="h-8"></div>;
  }

  if (verificationStatus.data === VerificationStatus.Verified) {
    return <div className="h-8"></div>;
  }

  return (
    <div className="flex flex-col items-center py-4">
      <div className="verify-email-container">
        <AlertMessage tone="caution" showIcon>
          <div>
            <p
              dangerouslySetInnerHTML={{
                __html: translate(
                  'Verify your email by {0} to avoid losing access.'
                ).format(
                  `<b>${VERIFY_EMAIL_ALERT_EXPIRATION_DATE.toLocaleDateString(
                    language,
                    {
                      month: 'long',
                      day: 'numeric',
                    }
                  )}</b>`
                ),
              }}
            />
            <p>
              {translate(
                "Email verification is required to secure your account—it's quick and easy!"
              )}{' '}
              <Link href="#confirm-email">{translate('Verify Email')}</Link>{' '}
            </p>
          </div>
        </AlertMessage>
      </div>
    </div>
  );
}
